

// components/tracking/ErrorMessage.jsx
import React from 'react';
import { motion } from 'framer-motion';
import { FaExclamationCircle } from 'react-icons/fa';

const ErrorMessage = ({ status, awb, onRetry }) => (
  <motion.div
    initial={{ scale: 0.9, opacity: 0 }}
    animate={{ scale: 1, opacity: 1 }}
    className="flex-1 flex flex-col items-center justify-center text-center px-4 py-20"
  >
    <div className="bg-white rounded-lg shadow-lg p-8 max-w-md w-full">
      <FaExclamationCircle className="text-red-500 text-5xl mb-4 mx-auto" />
      <h3 className="text-xl font-semibold text-gray-800 mb-2">
        {status === 'notfound' ? 'Tracking Not Found' : 'Something Went Wrong'}
      </h3>
      <p className="text-gray-600 mb-6">
        {status === 'notfound'
          ? `We couldn't find any tracking information for AWB: ${awb}`
          : 'An error occurred while fetching your tracking information. Please try again.'}
      </p>
      <button
        onClick={onRetry}
        className="bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2 px-6 rounded-lg transition-colors duration-200"
      >
        Try Again
      </button>
    </div>
  </motion.div>
);

export default ErrorMessage;

// ============================================================================